import axios from '../utils/axios';

export default function updateXMLFeedExcludedUsers(adminId, id, action, data) {
    return axios.post(`/admin/${adminId}/xml-feeds/excluded-users/${id}/action/${action}`, data);
}
